export const SelectAll = ({ ids, picked, setPicked, testid }) => {
  const all = ids.length > 0 && ids.every((id) => picked.includes(id));
  const toggle = () => setPicked(all ? picked.filter((x) => !ids.includes(x)) : [...new Set([...picked, ...ids])]);
  return (
    <label className="h-9 px-3 rounded-md border bg-white text-sm flex items-center gap-1.5 cursor-pointer select-none" data-testid={testid}>
      <input type="checkbox" checked={all} disabled={!ids.length} onChange={toggle} data-testid={`${testid}-checkbox`} />
      Select all on this page ({ids.length})
    </label>
  );
};
